import CameraAltIcon from "@mui/icons-material/CameraAltOutlined";
import UploadIcon from "@mui/icons-material/UploadOutlined";
import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";

function UploadModal(props) {
  const { open, onUploadSuccess, onSetErrorField, onOpenCamera, onClose } =
    props;

  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 639);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const renderModalClass = () => {
    let modalClass = "w-89.5 bg-white m-auto rounded-2xl p-6";
    if (isMobileView) {
      modalClass = "w-full bg-white mt-auto mx-auto p-3";
    }
    return modalClass;
  };

  const handleUseCamera = () => {
    onOpenCamera();
  };

  const handleFileChange = (e) => {
    let file = e.target.files[0];
    if (file) {
      if (file.size > 1000000) {
        onSetErrorField("attachment");
      } else {
        onSetErrorField("");
      }
      onUploadSuccess(file);
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className={renderModalClass()}>
        <div className="w-full mb-3">
          <label
            htmlFor="attachment"
            className="flex justify-between items-center rounded-md text-semibold sm:border cursor-pointer px-3 py-2"
          >
            <span>Upload</span>
            <UploadIcon sx={{ color: "#60656D" }} />
          </label>

          <input
            type="file"
            className="hidden"
            id="attachment"
            name="attachment"
            accept=".png, .jpg, .jpeg, .pdf"
            onChange={handleFileChange}
          />
        </div>
        <button
          className="flex justify-between rounded-md text-semibold w-full sm:border px-3 py-2"
          onClick={handleUseCamera}
        >
          <span>Use Camera</span>
          <CameraAltIcon sx={{ color: "#60656D" }} />
        </button>
      </div>
    </Modal>
  );
}

UploadModal.propTypes = {
  onUploadSuccess: PropTypes.func.isRequired,
  onSetErrorField: PropTypes.func.isRequired,
  onOpenCamera: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default UploadModal;
